import React from 'react';
import { Row, Col, Divider } from 'antd';
import Button from '@mui/material/Button';
import { EastSharp } from '@mui/icons-material';
import ImageCard from '../../components/Cards/components/ImageCard';
import usePortfolioExchange from './usePortfolioExchange';
import Article from '../../components/Article';
const PortfolioExchange = () => {
    const {
        exchanges,
        loading,
        error,
        navToExchange
    } = usePortfolioExchange();

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    const handleExchangeClick = (exchangeName) => {
        const success = navToExchange(exchangeName);
        if (!success) {
            console.error(`Failed to navigate to exchange: ${exchangeName}`);
            // You might want to show a notification or handle this error case
        }
    };

    if (!exchanges || !Array.isArray(exchanges) || exchanges.length===0) return null;

    return (
        <div style={{ padding: '20px' }}>
            <div className={'w-4/5 mx-auto'}>
                <Article imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/CardIcons/3d-sphere.png'}
                         title={<span>IA Exchange&trade;</span>}
                     description={'Expand your strategies and enhance the personalization you provide for clients by leveraging ready to go portfolios on the IA Exchange'}
                     subtext={'New Feature'}
                     bgColor={'bg-gradient-to-b from-sky-100 to-blue-100'}
                     subtextColor={'text-sky-700'}
                />
                <Divider/>
                <Row gutter={[64, 64]} justify="start">
                {exchanges?.map((item) => (
                    <Col key={item?.fields?.name} xs={24} xl={12} xxl={8}>
                        <ImageCard
                            imgUrl={item?.fields?.imgUrl}
                            title={item?.fields?.name}
                            description={item?.fields?.description}
                            imgHeight={180}
                            onClick={() => handleExchangeClick(item?.fields?.name)}
                            action={
                                <Button
                                    variant="outlined"
                                    type="primary"
                                    endIcon={<EastSharp/>}
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent double navigation
                                        handleExchangeClick(item?.fields?.name);
                                    }}
                                >
                                    View Exchange
                                </Button>
                            }
                        />
                    </Col>
                ))}
            </Row>
            </div>
        </div>
    );
};

export default PortfolioExchange;